import MultiSelectAutoComplete from './MultiSelectAutoComplete';

export default MultiSelectAutoComplete;
